import UserAgreementContainer from './UserAgreementContainer';

export default UserAgreementContainer;
